export const products = [
    {
      id: '1',
      name: 'Smart One Pro',
      img: '/images/smart one pro.jpg',
      desc: 'Zamonaviy Smart One Pro terminali, yuqori tezlikda ishlash va OLED displey. Kichik do‘konlar uchun ideal. Kafolat: 12 oy.',
      price: '2 400 000 UZS',
      warranty: '12 oy',
      features: [
        'Displey - 6", capacitive, TFT with protective glass',
        'Ekran o`lchamlari - 1440 x 720 pixels',
        'Chipset - Kun T11, octa-core, 2.0 GHz',
        'Operatsion tizim - Android 9.0',
        'RAM - 2 GB',
        'ROM - 16 GB',
        'Batareya - Li-Ion, 7.6 V, 3000 mAh (5000 mAh optional)',
        'Simsiz tarmoqni qo`llab-quvvatlash - WiFi 802.11 b/g/n, Bluetooth 4.0',
        'Navigatsiya - GPS/BEIDOU',
        'Ulanish - 2G/3G/LTE',
        'Kamera - Main: 5 MP FF, front: 2 MP, 2D / 3D scanner',
        'Interfeys ulagichlari - 1x Type-C (OTG/Charge), 1x Type-C (Host 2.0)',
      ],
      videoId: 'dQw4w9WgXcQ'
    },
    {
      id: '2',
      name: 'Nexgo P200 (Mobil Kassa)',
      img: '/images/nexgo.png',
      desc: 'NEXGO P200 Android 9.X asosidagi 6 dyuymli aqlli POS-terminaldir. U 4G, Wi-Fi va Bluetooth kabi keng ko`lamli ulanish usullarini qo`llab-quvvatlaydi. NEXGO P200 shuningdek, past shovqin va kam quvvat sarfi afzalliklariga ega bo`lgan 80 mm/s bosib chiqarish tezligiga ega tezkor printerni qabul qiladi.',
      price: '2 300 000 UZS',
      warranty: '12 oy',
      features: [
        'Displey - 6 dyuymli HD+ sensorli ekran',
        'Chipset - Android 9, Quad-core 1,4 GHz',
        'Ulanish - 4G / 3G / 2G / WiFi / BT',
        'Batareya - Li-ion akkumulyatori 7.4V / 2600 mA / soat',
        'Chop etish tezligi 80 mm / sek',
        'Kontaktsiz bank kartalarini qabul qilish'
      ],
      videoId: '_zo6h7iGkkc'
    },
    {
      id: '3',
      name: 'Mobil Kassa',
      img: '/images/mkassa.png',
      desc: 'Har qanday Android smartfonida ishlaydigan qulay va funksional mobil kassa. Kassadan telefon, planshet, kompyuter, hamda noutbukda foydalanish mumkin.',
      price: '890 000 UZS',
      warranty: '',
      features: [
        'Har qanday Android smartfonida ishlaydi',
        'VMK №943ning barcha talablariga javob beradi',
        'Onlayn kassaning barcha funksiyalar',
        'Internetsiz 24 soatgacha oflayn rejimida ishlaydi',
        'Shtrix kod va aksiz tovar markirovka skaneri',
        'O`zbek va rus tildagi interfeys',
        'Chekda QR kodni chop etadi'
      ],
      videoId: 'dQw4w9WgXcQ'
    },
    {
      id: '4',
      name: 'Simurg-001',
      img: '/images/simurg001.png',
      desc: 'Ushbu NKM 2015-yildan boshlab mahalliy sharoitlarda loyihasi olib borildi. 2016-yil fiskal xotirali NKM lar Davlat reestriga kiritildi. So’ngra hukumatning tegishli qarorlariga asosan modernizatsiya qilindi va 2020-yil 2-aprel sanasida online NKM lar Davlat reestriga kiritildi.',
      price: '1 500 000 UZS',
      warranty: '6 oy',
      features: [
        'DT versiyasi - 03',
        'Akkumulyator - 6.3 v',
        'Istemol quvvati - 3 w',
        'Operatorlar soni - 30 ta',
        'Razryadligi - 12 ta',
        'Bo`limlar soni - 16 ta',
        'Portlar - USB, COM, Ethernet, SD-CARD,',
        'Modem - GPRS(opsiya), Wi-Fi',
        'Ekran sig`imi - 128 x 32',
      ],
      videoId: 'Mb8lwkT7e0E'
    },
    {
        id: '5',
        name: 'Orion-100F O’z',
        img: '/images/orion100FUZ.png',
        desc: 'Nazort kassa mashinasi 2002-yil fiskal xotirali nazorat kassa mashinalari Davlat reestriga kiritilgan. Vazirlar mahkamasining 21-noyabr 2019-yildagi 943-qaror talablariga asosan tegishli o’zgartirishlar kiritilib 2020-yil 31-mart sanasi bilan onlayn kassa mashinalari Davlat reestriga kiritildi.',
        price: '0 UZS',
        warranty: '6 oy',
        features: [
            'DT versiyasi - 5.0',
            'Akkumulyator - 6v',
            'Istemol quvvati - 6w',
            'Operatorlar soni - 2',
            'Razryadligi - 8',
            'Bo`limalar soni - 8',
            'Portlar - Skaner uchun port, USB',
            'Simsiz aloqa - Wi-Fi, GPRS',
            'Ekran sig`imi - 120x32',
        ],
        videoId: 'oiGkfvoF3qI'
      },
      {
        id: '6',
        name: 'Merkuriy-115F O’z',
        img: '/images/merkuriy115.png',
        desc: 'Merkuriy-115F O’z Online nazorat kassa mashinasi 06.11.2020 yilda Davlat reestriga kiritildi.',
        price: '0 UZS',
        warranty: '6 oy',
        features: [
            'DT versiyasi - 1.0',
            'Akkumulyator - 7.4v',
            'Istemol quvvati - 7.4w',
            'Operatorlar soni - 16',
            'Razryadligi - 8',
            'Bo`limalar soni - 8',
            'Portlar - Skaner uchun port, USB',
            'Simsiz aloqa - Wi-Fi, GPRS',
            'Ekran sig`imi - 120x32',
        ],
        videoId: 'dQw4w9WgXcQ'
      }
  ];
  